import {
  Page, Section, SubSection, ElementType, EventType,
} from './constants';

export const AccountDetailsEvents = {
  firstNameCompleted: () => ({
    event: 'first name completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  lastNameCompleted: () => ({
    event: 'last name completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  companyNameCompleted: () => ({
    event: 'company name completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  companyWebsiteCompleted: () => ({
    event: 'company website completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  countryCodeCompleted: () => ({
    event: 'country code completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.click,
    },
  }),
  phoneNumberCompleted: () => ({
    event: 'phone number completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  yourRoleCompleted: role => ({
    event: 'your role completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      subSection: SubSection.yourRole,
      elementType: ElementType.input,
      eventType: EventType.click,
      role,
    },
  }),
  emailVolumeCompleted: emailVolume => ({
    event: 'email volume completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      subSection: SubSection.howManyEmails,
      elementType: ElementType.input,
      eventType: EventType.click,
      emailVolume,
    },
  }),
  employeeCountCompleted: employeeCount => ({
    event: 'employee count completed',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
      subSection: SubSection.howManyEmployees,
      elementType: ElementType.input,
      eventType: EventType.click,
      employeeCount,
    },
  }),
  accountBanned: () => ({
    event: 'account banned',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
    },
  }),
  accountProvisioned: () => ({
    event: 'account provisioned',
    properties: {
      page: Page.accountDetails,
      section: Section.tellUsAboutYourself,
    },
  }),
  easeAdded: easeAddon => ({
    event: 'ease added',
    properties: {
      page: Page.accountInputs,
      section: Section.tellUsAboutYourself,
      easeAddon,
    },
  }),
  ipAdded: ipAddon => ({
    event: 'ips added',
    properties: {
      page: Page.accountInputs,
      section: Section.tellUsAboutYourself,
      ipAddon,
    },
  }),
};
